import React from 'react'

const Close = (props) => {
  const imgClick = () => {
    props.imgSvgHandler()
  }
  return (
    <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={imgClick}
  >
    <circle
      cx="12"
      cy="12"
      r="11"
      fill="#0D0C22"
      stroke="white"
      strokeWidth="2"
    ></circle>
    <g clipPath="url(#clip0)">
      <path
        d="M15.7766 8.21582L8.86487 15.1275"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M15.7823 15.1347L8.86487 8.21582"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0">
        <rect
          width="10.3784"
          height="10.3784"
          fill="white"
          transform="translate(7.13513 6.48633)"
        ></rect>
      </clipPath>
    </defs>
  </svg>
  )
}

export default Close
